// theme.js
import { createTheme } from "@mui/material/styles";

// Assuming direction is defined somewhere in your code
const direction = "ltr"; // or "rtl" based on your requirements

const theme = createTheme({
  direction: direction,
  typography: {
    fontFamily:
      direction === "rtl"
        ? "'Noto Naskh Arabic', sans-serif"
        : "'Noto Sans', sans-serif",
  },
  palette: {
    primary: {
      main: "#247CAE", // Custom primary color
    },
    secondary: {
      main: "#dc004e", // Custom secondary color
    },
    background: {
      default: "#faf7f7", // Background color
      paper: "#FFFFFF", // Paper background color
    },
    text: {
      primary: "#333333", // Primary text color
      secondary: "#666666", // Secondary text color
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "5px", // Custom border radius for buttons
          padding: "5px 10px", // Custom padding for buttons
          textTransform: "none", // Disable uppercase transformation
          "&:hover": {
            backgroundColor: "#1976d2", // Hover background color
            color: "#ffffff", // Hover text color
          },
        },
      },
    },
  },
});

export default theme;
